
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
class PickupCode extends Vue {
  @Prop({ default: () => { } }) wrapStyle: string;
  @Prop({ default: "" }) value: string;

}
export default PickupCode
